import { Routes } from '@angular/router';
import { provideTranslocoScope } from '@jsverse/transloco';
import { authGuard } from 'src/core/guards';
import { appRoutesNames } from './app.routes.names';

export const appRoutes: Routes = [
  {
    path: appRoutesNames.ASSESSMENTS,
    canMatch: [authGuard],
    loadChildren: () =>
      import('./assessments/assessments.routes').then(
        (module) => module.assessmentsRoutes,
      ),
    providers: [provideTranslocoScope({ scope: 'assessments' })],
    data: { translocoScope: 'assessments' },
  },
];
